/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S6_TitleInputs */

const en_guide_large_json_files_s6_title = /** @type {(inputs: Guide_Large_Json_Files_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance Tips for PureJSON`)
};

const ko_guide_large_json_files_s6_title = /** @type {(inputs: Guide_Large_Json_Files_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON 성능 팁`)
};

const ja_guide_large_json_files_s6_title = /** @type {(inputs: Guide_Large_Json_Files_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONでのパフォーマンスヒント`)
};

/**
* | output |
* | --- |
* | "Performance Tips for PureJSON" |
*
* @param {Guide_Large_Json_Files_S6_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s6_title = /** @type {((inputs?: Guide_Large_Json_Files_S6_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S6_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s6_title(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s6_title(inputs)
	return ja_guide_large_json_files_s6_title(inputs)
});